export default __webpack_public_path__ + "static/media/out.bd8f30dc.JPG";